const baseTheme = {
  fonts: {
    mono: "'Futura PT',-apple-system,'BlinkMacSystemFont','Segoe UI','Roboto','Helvetica Neue','Arial','Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji'",
  },
};

const lightTheme = {
  ...baseTheme,
  colors: {
    background: '#fff',
    heading: '#000',
    text: '#353535',
    textGrey: '#77756E',
    textGrey2: '#2b2b2b',
    preFormattedText: 'rgb(245, 247, 249)',
    link: '#36a509',
  },
};

const darkTheme = {
  ...baseTheme,
  colors: {
    background: '#001933',
    heading: '#fff',
    text: '#fff',
    textGrey: '#77756E',
    textGrey2: '#e3e3e3',
    preFormattedText: '#000',
    link: '#36a509',
  },
};

export { lightTheme, darkTheme };
